declare global {
  interface Window {
    globalConfig: {
      REACT_APP_USE_MOCKS?: string;
      REACT_APP_CLIENT_ISSUER_R2C?: string;
      REACT_APP_CLIENT_REFERRER_R2C?: string;
      REACT_APP_CLIENT_ISSUER_1LINK?: string;
      REACT_APP_CLIENT_REFERRER_1LINK?: string;
      REACT_APP_GRANT_TYPE?: string;
      REACT_APP_CLIENT_ID?: string;
      REACT_APP_CLIENT_SCOPE?: string;
      REACT_APP_CLIENT_ISSUER?: string;
      REACT_APP_API_BASE_URL?: string;
      REACT_APP_HOMEPAGE?: string;
      REACT_APP_CLIENT_NAME_SN?: string;
      REACT_APP_CLIENT_NAME_R2C?: string;
      REACT_APP_SWITCH_BETWEEN_CLIENT?: string;
      NODE_ENV?:string;
    };
  }
}

const REACT_APP_USE_MOCKS = window.globalConfig?.REACT_APP_USE_MOCKS;
const REACT_APP_CLIENT_ISSUER_R2C= window.globalConfig?.REACT_APP_CLIENT_ISSUER_R2C;
const REACT_APP_CLIENT_REFERRER_R2C= window.globalConfig?.REACT_APP_CLIENT_REFERRER_R2C;
const REACT_APP_CLIENT_ISSUER_1LINK= window.globalConfig?.REACT_APP_CLIENT_ISSUER_1LINK;
const REACT_APP_CLIENT_REFERRER_1LINK= window.globalConfig?.REACT_APP_CLIENT_REFERRER_1LINK;
const REACT_APP_GRANT_TYPE= window.globalConfig?.REACT_APP_GRANT_TYPE;
const REACT_APP_CLIENT_ID= window.globalConfig?.REACT_APP_CLIENT_ID;
const REACT_APP_CLIENT_SCOPE= window.globalConfig?.REACT_APP_CLIENT_SCOPE;
const REACT_APP_CLIENT_ISSUER= window.globalConfig?.REACT_APP_CLIENT_ISSUER;
const REACT_APP_API_BASE_URL= window.globalConfig?.REACT_APP_API_BASE_URL;
const REACT_APP_HOMEPAGE= window.globalConfig?.REACT_APP_HOMEPAGE;
const REACT_APP_CLIENT_NAME_SN= window.globalConfig?.REACT_APP_CLIENT_NAME_SN;
const REACT_APP_CLIENT_NAME_R2C= window.globalConfig?.REACT_APP_CLIENT_NAME_R2C;
const REACT_APP_SWITCH_BETWEEN_CLIENT= window.globalConfig?.REACT_APP_SWITCH_BETWEEN_CLIENT;
const NODE_ENV= window.globalConfig?.NODE_ENV;



export const ENV_VARIABLES = {
      REACT_APP_USE_MOCKS,
      REACT_APP_CLIENT_ISSUER_R2C,
      REACT_APP_CLIENT_REFERRER_R2C,
      REACT_APP_CLIENT_ISSUER_1LINK,
      REACT_APP_CLIENT_REFERRER_1LINK,
      REACT_APP_GRANT_TYPE,
      REACT_APP_CLIENT_ID,
      REACT_APP_CLIENT_SCOPE,
      REACT_APP_CLIENT_ISSUER,
      REACT_APP_API_BASE_URL,
      REACT_APP_HOMEPAGE,
      REACT_APP_CLIENT_NAME_SN,
      REACT_APP_CLIENT_NAME_R2C,
      REACT_APP_SWITCH_BETWEEN_CLIENT,
      NODE_ENV
};
